const routes = {
  LOGIN_PAGE: '/login',
  SIGNUP_PAGE: '/signup',
  JOBDETAILS: '/job/:jobId',
  ROOT: '/',
  JOBPOST:'/jobpost',
  COMPANYUPDATE:'/companyDetails',
  JOBS:'/jobs',
  ADMINCOMPANIES: '/admin/companies',
  ADMINJOBS: '/admin/jobs',
  ADDCOMPANY: '/admin/addCompany',
  ADMINUPDATECOMPANY: '/admin/company/:companyId',
  COMPANYJOBS: '/company/jobs/:companyId',
  ADMINVETERANS: '/admin/users',
  FORGOTPASSWORD:'/forgotpassword',
  RESETPASSWORD:'/resetpassword/:resetToken'
};
export default routes;